import corporate from "./corporate.component";
import CorporateTransforms from "./corporate.transforms";
import corporateUrls from "./corporate.urls";

const corporateModule = angular
  .module("app.components.corporate", [])
  .component("corporatePage", corporate)
  .service("CorporateTransforms", CorporateTransforms)
  .config(corporateUrls);

export default corporateModule;



// WEBPACK FOOTER //
// ./src/pages/corporate/corporate.module.js